<template>
  <status-icon
    :status="status"
    :size="size"
    :statuses="statuses"
  ></status-icon>
</template>

<script>
import { ref } from '@vue/composition-api'
import StatusIcon from '@/components/statusIcon/StatusIcon.vue'
import useEventsStatusesList from '@/components/lists/eventsStatuses'

export default {
  components: {
    StatusIcon,
  },
  props: {
    status: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  setup() {
    const { eventsStatusesList } = useEventsStatusesList()
    const statuses = ref(eventsStatusesList)

    return {
      statuses,
    }
  },
}
</script>
